<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <div>
          <h1 class="title font-weight-light mb-lg-1">
            <v-icon class="mb-1" left>mdi-format-list-bulleted-type</v-icon>Ürün Listeleri
          </h1>
          <div class="pr-lg-15 mb-1"></div>
          <p class="text-caption font-weight-light mb-0">
            Ürünleri seçerek listeler oluşturup anasayfada görüntüleyebilir veya
            gruplayabilirsiniz
          </p>
        </div>
      </v-col>
      <v-col cols="12" lg="7">
        <v-card>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center px-2">Sıra</th>
                  <th class="text-left">Baslik</th>
                  <th class="text-left">Açıklama</th>
                  <th class="text-left">Ürünler</th>
                  <th class="text-left">Durum</th>
                  <th class="text-left">İşlem</th>
                </tr>
              </thead>
              <draggable
                v-bind="dragOptions"
                id="urunListeleriTbody"
                tag="tbody"
                @update="endDrag"
                :list="draggableUrunListesi"
                v-show="draggableUrunListesi.length > 0"
              >
                <tr v-for="liste in draggableUrunListesi" :key="liste.baslik">
                  <td class="liste-tasi px-2">
                    <v-icon>mdi-drag-vertical</v-icon>
                  </td>
                  <td>
                    <strong>{{ liste.baslik }}</strong>
                  </td>
                  <td>{{ liste.aciklama }}</td>
                  <td>
                    <div class="d-flex align-center">
                      <span class="mr-4 text-caption">
                        <strong>{{ liste.urunler.length }}</strong> adet seçildi
                      </span>
                      <v-btn
                        x-small
                        class="text-capitalize"
                        color="blue"
                        dark
                        depressed
                        @click="urunleriListele(liste)"
                      >
                        <v-icon left style="top:-1px">mdi-eye</v-icon>Listele
                      </v-btn>
                    </div>
                  </td>
                  <td>
                    <div class="mx-auto">
                      <v-switch
                        class="durum-switch"
                        color="success"
                        hide-details
                        @change="yayinDurumunuDegistir($event, liste.id)"
                        inset
                        :input-value="boolCevir(liste.durum)"
                      ></v-switch>
                    </div>
                  </td>
                  <td>
                    <div class="d-flex">
                      <v-tooltip bottom color="black">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-on="on"
                            v-bind="attrs"
                            icon
                            small
                            :loading="(listeDuzenle === liste.id)"
                            @click="listeyiDuzenle(liste.id)"
                            :disabled="!!(listeDuzenle !== liste.id && listeDuzenle)"
                          >
                            <v-icon color="grey" size="18">mdi-pencil</v-icon>
                            <template v-slot:loader>
                              <span class="custom-loader">
                                <v-icon color="green" light>mdi-cached</v-icon>
                              </span>
                            </template>
                          </v-btn>
                        </template>
                        <span>Listeyi Düzenle</span>
                      </v-tooltip>
                      <v-tooltip bottom color="red darken-3">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-on="on"
                            v-bind="attrs"
                            icon
                            small
                            @click="listeyiKaldirOnay(liste.id)"
                          >
                            <v-icon color="grey" size="18">mdi-delete</v-icon>
                          </v-btn>
                        </template>
                        <span>Listeyi Kaldır</span>
                      </v-tooltip>
                    </div>
                  </td>
                </tr>
              </draggable>
            </template>
          </v-simple-table>
          <div
            v-show="draggableUrunListesi.length === 0"
            class="text-center grey--text text-overline px-3 py-3"
          >
            <v-icon style="top:-2px" size="18">mdi-alert-circle</v-icon>
            {{noDataText}}
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" lg="5">
        <urun-listesi-ekle v-if="!listeDuzenle" />
        <urun-listesi-duzenle v-else @clear="duzenlemeIptal" />
      </v-col>
    </v-row>

    <v-dialog v-model="listeKaldirDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline red--text text--darken-4">
          <v-icon left color="red darken-4">mdi-close-octagon</v-icon>Uyarı
        </v-card-title>
        <v-card-text>
          Ürün listesini sistemden
          <strong>tamamen</strong> kaldırmak istediğinize emin misiniz ?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="listeKaldirDialog = false">İptal</v-btn>
          <v-btn
            color="green darken-1"
            text
            :loading="listeKaldirOnayStatus"
            @click="listeyiKaldir"
          >Evet</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="urunleriListeleDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline blue--text mb-4">
          <v-icon left color="red darken-4">mdi-list</v-icon>Listeye ait ürünler
          <v-divider />
        </v-card-title>
        <v-card-text>
          <div :key="key" v-for="(urun, key) in urunleriListeleUrunler">
            <div class="d-flex align-center mb-2">
              <div class="mr-2">
                <img width="80" :src="`${$urunResimUrl.sm}${$urunResim.ilkResim(urun.resimler)}`" />
              </div>
              <div>
                <div class="font-weight-bold black--text">{{urun.name}}</div>
                <div class="font-weight-light">{{urun.kod}}</div>
              </div>
            </div>
            <v-divider />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue" text @click="urunleriListeleDialog = false">Kapat</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import UrunListesiEkle from "@/components/Modules/Urunler/UrunListesiEkle.vue";
import UrunlerService from "@/services/UrunlerService";
import UrunListesiDuzenle from "@/components/Modules/Urunler/UrunListesiDuzenle.vue";
import Draggable from "vuedraggable";
import _ from "lodash";
export default {
  name: "UrunListeleri",
  components: { UrunListesiEkle, Draggable, UrunListesiDuzenle },
  data: () => ({
    noDataText: "Oluşturulmuş ürün listesi bulunamadı",
    headers: [
      { text: "Liste Adı", value: "resimler", sortable: false },
      { text: "Açıklama", value: "name", sortable: false },
      { text: "Ürünler", value: "renkler", sortable: false }
    ],
    listeKaldirID: "",
    listeKaldirOnayStatus: false,
    listeKaldirDialog: false,
    draggableUrunListesi: [],
    listeDuzenle: null,
    urunleriListeleDialog: false,
    urunleriListeleUrunler: []
  }),
  computed: {
    ...mapState({
      urunListeleri: state => state.Urunler.UrunListeleri.urunListeleri
    }),
    dragOptions() {
      return {
        animation: 0,
        group: "widget",
        disabled: false,
        ghostClass: "ghost",
        put: () => true,
        pull: false
      };
    }
  },
  methods: {
    urunleriListele(liste) {
      const listeID = liste.id;
      this.urunleriListeleUrunler = [];
      this.$store
        .dispatch("Urunler/UrunListeleri/urunListeDetay", listeID)
        .then(res => {
          if (res.status === 200) {
            /**
             * Gelen ürünler ile liste içerisindeki kodları
             * eşleştir. Aynı üründen ne kadar varsa tekrar tekrar
             * liste içerisine dahil et
             */
            liste.urunler.forEach(urunCode => {
              this.urunleriListeleUrunler.push(
                _.find(res.data.urunler, o => {
                  return o.code == urunCode;
                })
              );
            });
            this.urunleriListeleDialog = true;
          } else {
            this.$snotify.error(res.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
          }
        });
    },
    yayinDurumunuDegistir(e, id) {
      const listeID = id,
        durum = e,
        message = e === true ? "yayına alınmıştır" : "yayından kaldırılmıştır";

      UrunlerService.setUrunListeDurum({ listeID, durum }).then(res => {
        if (res.status === 200) {
          this.$snotify.success(`Liste başarıyla ${message}`, this.$t('PANEL.NOTIFY.SUCCESS'));
        } else {
          this.$snotify.error(res.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
        }
      });
    },
    listeyiDuzenle(listeID) {
      this.$store
        .dispatch("Urunler/UrunListeleri/urunListeDetay", listeID)
        .then(() => {
          this.listeDuzenle = listeID;
        });
    },
    duzenlemeIptal(e) {
      this.listeDuzenle = e;
    },
    listeyiKaldirOnay(listeID) {
      this.listeKaldirID = listeID;
      this.listeKaldirDialog = true;
    },
    listeyiKaldir() {
      const listeID = this.listeKaldirID;
      this.listeKaldirOnayStatus = true;
      this.$store
        .dispatch("Urunler/UrunListeleri/urunListeKaldir", listeID)
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(
              "Liste başarıyla sistemden kaldırılmıştır",
              this.$t('PANEL.NOTIFY.SUCCESS')
            );
          } else {
            this.$snotify.error(res.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
          }
        })
        .then(() => {
          this.listeKaldirOnayStatus = false;
          this.listeKaldirID = "";
          this.listeKaldirDialog = false;
          this.listeDuzenle = false;
        });
    },
    endDrag() {
      var listeSirasi = {};
      for (let index = 0; index < this.draggableUrunListesi.length; index++) {
        let listeID = this.draggableUrunListesi[index].id;
        listeSirasi[index + 1] = listeID;
      }
      this.$store
        .dispatch("Urunler/UrunListeleri/setListeSiralama", listeSirasi)
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(
              "Liste sıralaması güncellenmiştir",
              this.$t('PANEL.NOTIFY.SUCCESS')
            );
          } else {
            this.$snotify.error(res.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
          }
        });
    },
    boolCevir(d) {
      return !!parseInt(d);
    }
  },
  created() {
    this.$store.dispatch("Urunler/UrunListeleri/urunListeleri");
  },
  watch: {
    urunListeleri: {
      handler(val) {
        this.draggableUrunListesi = JSON.parse(JSON.stringify(val));
      },
      immediate: true
    }
  }
};
</script>

<style scoped>
#urunListeleriTbody td {
  vertical-align: middle;
  padding-top: 7px;
  padding-bottom: 7px;
}
.liste-tasi {
  cursor: move;
}
.durum-switch {
  position: relative;
  top: -10px;
  left: 5px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.custom-loader {
  animation: loader 13s linear infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
